import React, { useCallback, useState } from 'react';

import { Divider, Link } from '@material-ui/core'

import { RichTextEditor, ImageUpload, Select, TextInput } from '../EditorFormElements';
import { Collapsible, FormFieldWrapper } from '../Global';

import { basicRTEControls, iconSetOptions } from '../../config/allInteractives';
import makePath from '../../utils/makePath';

export const Tile = React.memo(({ given = {}, index, pretitle, type, ...props }) => {
  const [label, setLabel] = useState( given.label ? given.label : `Tile ${index + 1}`)

  const callback = useCallback((name,value) => setLabel(value), [setLabel]);

  const path = makePath(props.path,index);
  
  let labelLimit;
  if (type === 'word') {
    labelLimit = 12
  } else if (type === 'character' ) {
    labelLimit = 1
  }

  return (
    <Collapsible headerTag="h4" title={label} sortableChild>
      <FormFieldWrapper>
        <TextInput 
          label="Node Label"
          callback={callback}
          defaultText={`Tile ${index + 1}`}
          path={path} 
          name="node" 
          given={given.node}
        /> 
        
        <TextInput 
          label={type === 'icon' ? "Tile Label Icon Name" : "Tile Label"}
          defaultText={type === 'icon' ? "star" : index + 1}
          path={path}
          name="label"
          max={labelLimit} 
          absoluteMax={labelLimit === 1 ? labelLimit : null}
          given={given.label}
          validationCriteria={{
            optional:false,
            mustChange: false,
          }}
          help={type === 'icon' ? <span>Browse available icons on the Font Awesome Cheatsheet website. Copy and paste the icon’s name into the field (e.g. star). The icon will display within the interactive. <Link href="//fontawesome.com/cheatsheet" target="_blank" rel="noopener noreferrer">Browse Icons</Link></span> : ''}
        /> 
          
        {type === 'icon' ?
          <Select
            label="Icon Set"
            name='iconSet'
            path={path}
            options={iconSetOptions}
            given={given.iconSet}
          />
          : ''
        }

        <ImageUpload 
          label="Upload Tile Background Image" 
          path={path} 
          name="bg"
          tooltip="Upload an image to display in the background of the tile. Image must be 420px wide and 770px tall and must not exceed 25KB."
          given={given.bg}
          optional
          help="This image is optional."
        />
      </FormFieldWrapper>

      <Divider />

      <FormFieldWrapper>
        {pretitle ? 
          <TextInput 
            label="Preheading" 
            defaultText="Preheading Text"
            path={path}
            name="pretitle" 
            width="wide"
            given={given.pretitle}
          />
        :''}

        <TextInput 
          label="Heading" 
          defaultText="Heading Text"
          path={path}
          name="title" 
          max={12} 
          given={given.title}
        /> 
      
        <RichTextEditor 
          // label="Panel Body" 
          path={path}
          name="body"
          defaultValue="Enter body text for the tile."
          controls={basicRTEControls} 
          given={given.body}
        />
      </FormFieldWrapper>

      {props.deleteBtn}

    </Collapsible>
  )
})